import React, {Component} from 'react'


const ooo = () => {
    return(
        <>

        as;lfjasifhaslkbfh
        </>
    )
}
export default ooo